export const ACCEPT_FILE_TYPES = ".doc, .docx, .jpg, .jpeg, .psd, .pdf, .txt, .xls, .xlsx, .png";

export enum INPUT_TYPES {
  PASSWORD = "password",
  TEXT = "text",
}

export enum MODAL_TYPES {
  CONFIRM = "CONFIRM",
  GENERATE_FILE = "GENERATE_FILE",
  ACCOUNT_PAYMENT = "ACCOUNT_PAYMENT",
  CREATE_PROPERTY_LIST = "CREATE_PROPERTY_LIST",
  NEW_PROPERTY_LIST = "NEW_PROPERTY_LIST",
  DOWNLOAD_CSV_PROPERTY_RECORDS = "DOWNLOAD_CSV_PROPERTY_RECORDS",
  DISPUTE_PAY_PER_LEAD = "DISPUTE_PAY_PER_LEAD",
  IMAGE_PREVIEW = "IMAGE_PREVIEW",
  ASSIGN_LEAD_TO_PROPERTY = "ASSIGN_LEAD_TO_PROPERTY",
  MOVE_USER_TO_ANOTHER_COMPANY = "MOVE_USER_TO_ANOTHER_COMPANY",
  EDIT_COUNTY_PRICE = "EDIT_COUNTY_PRICE",
  APPLY_COUNTY_PRICE = "APPLY_COUNTY_PRICE",
  CANCEL_PAY_PER_LEAD_SUBS = "CANCEL_PAY_PER_LEAD_SUBS",
  CANCEL_NICHE_SUBS = "CANCEL_NICHE_SUBS",
  PPL_BUYER_PROFILE = "PPL_BUYER_PROFILE",
  ADJUST_ACCOUNT_BALANCE = "ADJUST_ACCOUNT_BALANCE",
  REISIFT_INTEGRATION = "REISIFT_INTEGRATION",
  SEND_FILES_TO_REISIFT = "SEND_FILES_TO_REISIFT",
}

export enum OVERLAY_TYPES {
  CREATE_EDIT_CLIENT = "CREATE_EDIT_CLIENT",
  CREATE_EDIT_COMPANY = "CREATE_EDIT_COMPANY",
  EDIT_DEAL = "EDIT_DEAL",
  TICKET_HISTORY = "TICKET_HISTORY",
  TICKET_NOTES = "TICKET_NOTES",
}

export const FILE_PREVIEW_GET_REQUEST_INTERVAL = 5000;
export const INVESTOR_FILE_GET_REQUEST_INTERVAL = 5000;

export enum MAX_FIELDS_COUNTS {
  MAX_EMAILS_COUNT = 3,
  MAX_NUMBERS_COUNT = 4,
}

export const NotAvailableText = "N/A";
export const NotAvailablePlaceholder = "-";
export const PaymentFailedMessage = "Payment has failed, please update your payment method and try again.";
export const INTEGRATIONS_REISIFT_MODAL = "integrations_show_reisift_modal";
export const INTEGRATIONS_REISIFT_COUPON = "reisift-promo";

export const SESSION_EXPIRED_MESSAGE = "Your session has expired. Please log in to continue.";
